import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const controlPanelSlice = createSlice({
  name: "controlPanel",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      const { date, department, county, location, devEui } = action.payload;

      state.date = date;
      state.department = department;
      state.county = county;
      state.location = location;
      state.devEui = devEui;
    },
    setDate: (state, action) => {
      const { date } = action.payload;
      state.date = date;
    },
    setDepartment: (state, action) => {
      const { department } = action.payload;
      state.department = department;
    },
    setCounty: (state, action) => {
      const { county } = action.payload;
      state.county = county;
    },
    setLocation: (state, action) => {
      const { location } = action.payload;
      state.location = location;
    },
    setDevEui: (state, action) => {
      const { devEui } = action.payload;
      state.devEui = devEui;
    },
  },
});

export const {
  setFilters,
  setDate,
  setDepartment,
  setCounty,
  setLocation: setZone,
  setDevEui,
} = controlPanelSlice.actions;
export default controlPanelSlice.reducer;
